import * as signalR from '@aspnet/signalr';
import {myUUID} from './apiUtils';

let connection;

export const startListening = (connectionString, onMessageReceived, onError) => {
	connection = new signalR.HubConnectionBuilder()
		.withUrl(connectionString.url, { accessTokenFactory: () => connectionString.accessToken })
		.configureLogging(signalR.LogLevel.Information)
		.build();

	connection.on('newMessage', data => {
		// if this message originated from this window, ignore the message.
		if (data.browserId === myUUID) {
			return;
		}

		onMessageReceived && onMessageReceived(data);
	});
	connection.onclose(function() {
		console.log('signalr disconnected');
	});

	connection
		.start()
		.then(res => {})
		.catch(console.error);
};

export const stopListening = async () => {
	connection.close();
}
